import { render, staticRenderFns } from "./FittCardsDeck.vue?vue&type=template&id=7dc97ffa&scoped=true&"
import script from "./FittCardsDeck.vue?vue&type=script&lang=js&"
export * from "./FittCardsDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc97ffa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
